/** This should probably be a server-side object */
export const defaultDelayReasons = [
  'MTG statement',
  'HOI declarations',
  'LOE above 550',
  'LOE below 550',
  'ID applicant',
  'ID co-applicant',
  'Solar contract',
  'Solar finance agreement',
  'Marital status',
  'Trust docs',
  'LLC docs',
  'Signed app',
  'Tag UAM review property',
  'Signed authorization to release',
  'Signed CET authorization',
  'HOA contact',
  'Master insurance',
  'Tag UAM for third lien',
  'Credit frozen',
  'HELOC statement',
  'HELOC note',
  '36 months previous payment history',
  'Declarations',
  'FB initial agreement & extensions',
  'Loan mod (midprocess)',
  'Verify no MTG',
  'Spouses name',
  'POA',
  'POA LOE',
  'Email RP POA LOE ',
]
